var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('ul',_vm._l((_vm.upcoming_evaluations),function(evaluation){return _c('li',{key:evaluation.id,attrs:{"title":evaluation.description}},[_c('b-icon',{attrs:{"icon":"clock"}}),_c('router-link',{attrs:{"to":{
          name: 'AnswerView',
          params: { evaluation_id: evaluation.id },
          force: true,
        }}},[_vm._v(" "+_vm._s(_vm._f("toDate")(evaluation.start_date))+" - "+_vm._s(evaluation.name)+" ")])],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"title"},[_c('strong',[_vm._v("Próximas Evaluaciones")])])
}]

export { render, staticRenderFns }